const state = {
    alert: { isActive: false, options: {} },
    toast: { isActive: false, options: {} },
    prompt: { isActive: false, options: {}, callback: null },
    confirm: { isActive: false, options: {}, callback: null },
    loading: { isActive: false, options: {} },
}

/** 同步取值 通过 getters 来调用 */
const getters = {
    alert: st => st.alert,
    toast: st => st.toast,
    prompt: st => st.prompt,
    confirm: st => st.confirm,
    loading: st => st.loading,
}

/** 同步存值 通过 commit 来调用 */
const mutations = {
    show(st, type) {
        st[type].isActive = true;
    },
    hide(st, type) {
        st[type].isActive = false;
    },
    options: (st, options) => {
        var type = options.type;
        if ("callback" in options) {
            st[type].callback = options.callback;
            delete options.callback;//去掉callback属性
        }
        st[type].options = options;
    },
    callback: (st, params) => {
        var type = params.type;
        typeof st[type].callback == 'function' && st[type].callback(params.args);
    }
}

/** 异步存值 通过 dispatch 来调用 */
const actions = {
    async show({ commit }, type) { //最多只能传2个值
        commit('show', type)
    },
    async hide({ commit }, type) {
        commit('hide', type)
    },
    options: ({ commit }, options) => {
        commit("options", options);
    },
    callback: ({ commit }, params) => {
        commit("callback", params);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}